<template>
	<Modal v-if="shown"
			:title="$t('collection.collectionReport')"
			@close="closeModal"
			:close-on-click-outside="false"
			:width="1200"
	>
	<template v-slot:body>
		<div class="flex flex_column text_left modal-content">
			<div class="flex">
				<div class="flex_2 base_padding">
					<md-field displayOnly>
						<label>{{ $t("common.supplier") }}</label>
						<md-input :value="receivableInfo.sellerName" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.debtor") }}</label>
						<md-input :value="receivableInfo.debtorName" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.invoiceNumber") }}</label>
						<md-input :value="receivableInfo.invoiceNumber" disabled></md-input>
					</md-field>
					<md-field displayOnly>
						<label>{{ $t("common.amount") }}</label>
						<MoneyAmountInput v-model="receivableInfo.receivableAmount" disabled="true"></MoneyAmountInput>
					</md-field>
				</div>
			</div>
			<div class="flex table">
				<div class="flex flex_column w_100">
					<AgItem :columnDefs="columnDefs"
									:rowData="rowData"
									height="dynamic"
									min-height="124px"
					></AgItem>
				</div>
			</div>
			<div class="flex flex_end base_padding">
				<md-button class="md-blank" @click.stop="closeModal">{{ $t("common.close") }}</md-button>
			</div>
		</div>
	</template>
	</Modal>
</template>
<script>
import AgItem from "@/components/templates/agGrid/AgItem.vue";
import {allInvestmentsReceivablesApi} from "@/common/api/allInvestmentsReceivablesApi";
import Modal from "src/components/templates/modal/Modal";
import {enumDef} from "@/common/enumDefs";
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput.vue";

export default {
	components: {
		MoneyAmountInput,
		AgItem,
		Modal
	},
	beforeMount() {
	},
	data() {
		return {
			shown: false,
			columnDefs: [],
			rowData: null,
			receivableInfo: {},
		};
	},
	methods: {
		setColumnDefs() {
			this.columnDefs = [
				{
					headerName: this.$t("common.date"),
					field: "date",
					minWidth: 100,
				},
				{
					headerName: this.$t("collection.reminderState"),
					field: "dunningLevel",
					minWidth: 150,
					cellRendererFramework: "EnumAsText",
					enumDef: enumDef.dunningLevel,
				},
				{
					headerName: this.$t("collection.tciState"),
					field: "insuranceStatus",
					minWidth: 120,
					cellRendererFramework: "EnumAsText",
					enumDef: enumDef.insuranceStatus,

				},
				{
					headerName: this.$t("collection.obligatory"),
					field: "obligatory",
					minWidth: 80,
					cellRendererFramework: "EnumAsText",
					enumDef: enumDef.obligatory,
				},
				{
					headerName: this.$t("collection.reason"),
					field: "reason",
					minWidth: 200,
					cellRendererFramework: "EnumAsText",
					enumDef: enumDef.unpaidCaseActionReason,
				},
				{
					headerName: this.$t("common.remarks"),
					field: "note",
					cellRendererFramework: "GeneralShortenedDisplay",
					minWidth: 250,
				},
				{
					headerName: this.$t("common.documents"),
					field: "uploadedFiles",
					cellRendererFramework: "MultiFileLink",
					minWidth: 150,
				}
			]
		},
		showCollectionReportModal(data) {
			this.shown = true;

			this.setColumnDefs();
			this.receivableInfo = data;
			this.loadDetails(this.receivableInfo.receivableId);
		},
		closeModal() {
			this.shown = false;
		},
		loadDetails(receivableId) {
			allInvestmentsReceivablesApi.inspection
					.reminderLogHistory(receivableId)
					.then((res) => {
						this.rowData = res;
					})
			.catch(this.toast);
		}
	}
}
</script>